import FJConfig from "../../config/FJConfig";
import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  documentColors: FJConfig.defaultDocumentColors,
}

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.DOCUMENT_COLOR_CHANGED:
      return {
        ...state,
        documentColors: action.data,
      }
    default:
      return state;
  }
}